export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.1580efce.worker.js");
}
